<template lang="pug">
  FormModal(title="New Translation", endpoint="translations", :data="data", v-bind="$attrs", @success="success")
    InputGroup(label="Key", name="key", :error="errors.key"): TextInput(v-model="data.key", :disabled="translating", placeholder="e.g. copy_embed_code")
    InputGroup(label="Description", name="description", :error="errors.description"): TextInput(v-model="data.description", :disabled="translating", placeholder="Where and how this string is used")
    InputGroup(label="English", name="translations.en", :error="errors.value")
      TextInput(v-model="data.translations.en", :disabled="translating", :prepend="enLocale ? enLocale.icon : null", placeholder="The English text to translate")

    template(v-if="translated")
      hr.mb-8
      p.mb-8.text-sm.text-supplement Review the AI-generated translations below, edit any that need adjusting, then create the translation.
      template(v-for="locale in otherLocales")
        InputGroup(:label="`${locale.name} — ${locale.locale}`", :name="`translations.${locale.locale}`")
          TextInput(
            :name="`translation-${locale.locale}`",
            v-model="data.translations[locale.locale]",
            :disabled="translating",
            :prepend="data.translations[locale.locale] ? locale.icon : null",
            :prepend-icon="data.translations[locale.locale] ? null : 'exclamation-triangle'"
          )

    template(v-slot:footer)
      a.text-supplement(@click="$emit('close', false)") Cancel
      template(v-if="!translated")
        Button(type="primary", :disabled="translating || !data.translations.en", @click="aiTranslate")
          template(#prepend): Icon(:icon="translating ? 'spinner' : 'language'", :spin="translating")
          span {{ translating ? "Translating…" : "AI Translate" }}
      template(v-else)
        div.flex
          Button.mr-3(type="secondary", :disabled="translating", @click="aiTranslate")
            template(#prepend): Icon(:icon="translating ? 'spinner' : 'language'", :spin="translating")
            span {{ translating ? "Translating…" : "Re-translate" }}
          Button(type="primary", submit) Create Translation
</template>

<script>
export default {
  props: {
    locales: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    translating: false,
    translated: false,
    errors: {},
    data: {
      key: "",
      description: "",
      translations: {
        en: ""
      }
    }
  }),
  computed: {
    enLocale() {
      return this.locales.find(locale => locale.locale === "en")
    },
    otherLocales() {
      return this.locales.filter(locale => locale.locale !== "en")
    }
  },
  methods: {
    async aiTranslate() {
      if (!this.data.translations.en) return

      this.translating = true
      this.errors = {}

      try {
        const response = await this.$api.post("translations/translate", {
          key: this.data.key,
          description: this.data.description,
          value: this.data.translations.en
        })

        this.data.translations = { ...this.data.translations, ...response.data.translations }
        this.translated = true
      } catch (error) {
        // The translate request runs outside the form's submit lifecycle, so surface its
        // validation messages through InputGroup's `error` prop (a string per field).
        const errors = error?.response?.data?.errors || {}
        this.errors = Object.fromEntries(
          Object.entries(errors).map(([field, messages]) => [field, [].concat(messages).join(" ")])
        )
      } finally {
        this.translating = false
      }
    },
    success() {
      this.$notification.success(`Translation **${this.data.key}** successfully created.`)
      this.$emit("close", true)
    }
  }
}
</script>
